import React from "react";
import { Card, CardContent } from 'components/ui/card';
import { cn } from "lib/utils";

interface EarningBlockProps {
  title?: string,
  className?: string;
  total?: number | string;
  percentage?: string;
}

const EarningBlock = ({
  title = "Earnings",
  total = "$0",
  percentage = "+08%",
  className = "",
}: EarningBlockProps) => {

  return (
    <Card className={cn("", className)}>
      <CardContent className="py-3 px-4">
        <div className="flex flex-col gap-2 md:flex-row items-start">
          <div className="flex-1">
            <div className="text-sm text-default-600  mb-1.5">{title}</div>
            <div className="text-lg text-default-900  font-medium mb-1.5">
              {total}
            </div>
            <div className="!hidden font-normal text-xs text-default-600 whitespace-nowrap">
              <span className="text-primary me-1">{percentage}</span>
              From last week
            </div>
          </div>
          <div className="flex-none">

          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default EarningBlock;